/* 
 * Export component file to be used on project
*/

import NotificationInline from './NotificationInline'
export default NotificationInline
